<script setup>
import FormPanel from "@/components/ExperiencePage/Algolia/AlgoliaPanel.vue";
import { inject, computed } from "vue";
const inferenceFilters = inject("inferenceFilters");

const hasEntries = computed(() => {
  const arr = inferenceFilters.value[props.inferenceKey];
  return Array.isArray(arr) && arr.length > 0;
});

const props = defineProps({
  disablePanel: {
    type: Boolean,
    default: false,
  },
  mainPanelClass: {
    type: String,
    default: "max-w-351p",
  },
  inferenceKey: {
    type: String,
    default: "",
  },
});
</script>

<template>
  <FormPanel
    :main-panel-class="mainPanelClass"
    main-header-class="border-b-0"
    :panel-button-class="['w-full flex-row-reverse justify-between']"
    :panel-button-text-classes="['font-montserrat font-bold uppercase sm:leading-4.5 sm:tracking-wide']"
    :disable-panel="disablePanel"
    :initially-expanded="hasEntries"
  >
    <template #title>
      <slot name="title"></slot>
    </template>
    <template #content>
      <slot></slot>
    </template>
  </FormPanel>
</template>
